import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTripContext } from "./TripContext";
import "../../css/View/VariantDetails.css";
import VariantRegistrations from "./Registrations/VariantRegistrations";
import VariantDetailsActions from "./VariantDetailsActions";
import { useUser } from "../userContext";
import BulkCorrectionPopup from "./BulkCorrectionPopup";
import BulkMailPopup from "./BulkMailPopup";
import PhotoDetails from "./TripDetailsPhoto";

const VariantDetails = () => {
  const { variantguid } = useParams();
  const { tripData, error, hasExplicitAccess } = useTripContext();
  const [variant, setVariant] = useState(null);
  const [elements, setElements] = useState([]);
  const { user } = useUser();
  const [showCorrectionPopup, setShowCorrectionPopup] = useState(false);
  const activeSectionRef = useRef(null);
   const [showMailPopup, setShowMailPopup] = useState(false);

  const scrollToRegistrations = () => {
  activeSectionRef.current?.scrollIntoView({ behavior: "smooth" });
};

  const handleBulkCorrectionClick = () => setShowCorrectionPopup(true);

  useEffect(() => {
    if (tripData) {
      const foundVariant = tripData.variants.find((v) => v.guid === variantguid);
      setVariant(foundVariant);

      if (foundVariant) {
        const filteredElements = tripData.elements.filter((element) =>
          element.variants.includes(foundVariant.guid)
        );
        setElements(filteredElements);
      }
    }
  }, [tripData, variantguid]);

  const navigate = useNavigate();
const { guid: tripGuid } = useParams(); 

const handleAttendanceClick = () => {
  navigate(`/trips/${tripGuid}/variants/${variant.guid}/participants`);
};

const handleInsuranceClick = () => {
  navigate(`insurances`);
};

  const formatDateTime = (date) => {
    return new Date(date).toLocaleString("pl-PL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const hasSharedLimitedElements = (elements, currentVariantGuid) => {
    return elements.some(el =>
      el.isWithLimitedPlaces &&
      el.variants.includes(currentVariantGuid) &&
      el.variants.length > 1
    );
  };
  


  if (error) {
    return (
      <div className="variant-error-container">
        <div className="variant-error-title">Wystąpił błąd</div>
        <div className="variant-error-message">Nie udało się załadować danych wariantu.</div>
      </div>
    );
  }
  
  if (!variant) {
    return (
      <div className="variant-error-container">
        <div className="variant-error-title">Brak danych</div>
        <div className="variant-error-message">Nie znaleziono wariantu lub dane nie są dostępne.</div>
      </div>
    );
  }
  
  const isCoordinator = user?.id && variant.coordinators?.some(c => c.id === user.id);
  const canCreateRegistration = tripData?.status?.id === 3 || tripData?.status?.id === 5;

const registrationsForList = (tripData?.registrations || [])
  .filter((r) => r.variantGuid === variant?.guid)
  .filter((r) => {
    if (r.status === 3) return r.confirmedAt != null;
    if (r.status === 4) return true;
    if (r.status === 5) return r.confirmedAt != null;
    return false;                                
  })
  .map((r) => {
    const mainParticipant =
      (r.participants || []).find((p) => p.isPrimary)?.preferredName ?? "(osoba główna?)";
    const code =
      r.reservationCode || r.registrationCode || r.code || "(brak)";
    const balance =
      ((r.totalTransfersAmount ?? 0) - (r.outgoingTransfersAmount ?? 0)) -
      (r.amountToPay ?? 0);

    return {
      guid: r.reservationGuid,
      reservationCode: code,
      primaryParticipantName: mainParticipant,
      displayedBalance: balance.toFixed(2),
      participantsCount:
        (r.participants || []).filter((p) => p.status !== 5)
          .length,
      status: r.status,
    };
  })
  .sort((a, b) =>
    a.primaryParticipantName.localeCompare(b.primaryParticipantName, "pl", {
      sensitivity: "base",
    })
  );


      const handleBulkMailClick = () => setShowMailPopup(true);
  return (
    <>
          <VariantDetailsActions
              onRegistrationsClick={() => navigate("registrations")}
              onAttendanceClick={handleAttendanceClick}
              tripGuid={tripData.guid}
              variantGuid={variantguid}
              isCoordinator={isCoordinator}
              canCreateRegistration={canCreateRegistration}
              onInsuranceClick={handleInsuranceClick}
              onBulkCorrectionClick={handleBulkCorrectionClick}
              onScrollToRegistrations={scrollToRegistrations}
               onBulkMailClick={handleBulkMailClick}
               hasExplicitAccess={hasExplicitAccess}
            />
                  <PhotoDetails photoUrl={variant.variantPhotoLink || variant.variantPhotoThumbnailLink} altText={`Zdjęcie wariantu ${variant.name}`} />
        <div className="trip-variant-details">
    <div className="trip-variant-section trip-variant-info-table">
      <table>
        <tbody>
          <tr>
            <td className="trip-variant-label">Osoba kontaktowa</td>
            <td>
              {variant.coordinators.find(c => c.id === variant.primaryCoordinatorId)?.name ?? "Brak danych"}
              {variant.ccPrimaryCoordinatorInEmails && (
                <div className="email-copy-info">
                  <i className="fas fa-envelope" style={{ marginRight: '6px', color: '#555' }}></i>
                 Tryb kopii wiadomości automatycznych jest <b>&nbsp;włączony</b>.
                </div>
              )}
            </td>
          </tr>

          <tr>
            <td className="trip-variant-label">Pozostałe os. koord.</td>
            <td>
              {
                variant.coordinators
                  .filter(c => c.id !== variant.primaryCoordinatorId)
                  .map(c => c.name)
                  .join(", ") || "-"
              }
            </td>
          </tr>
          <tr>
          <td className="trip-variant-label">Limit miejsc</td>
          <td>
            {variant.capacity ?? "-"}
            {hasSharedLimitedElements(elements, variant.guid) && (
              <div className="shared-elements-warning">
                <strong>Uwaga!</strong> Wariant posiada współdzielone elementy, przez co limit miejsc jest wspólny dla więcej niż 1 wariantu.
              </div>
            )}
          </td>
        </tr>
          {variant.capacity != null && variant.availableSeats != null && (
              <tr>
                <td className="trip-variant-label">Wolne miejsca</td>
                <td>
                  {variant.availableSeats < 0
                    ? `0`
                    : variant.availableSeats}
                </td>
              </tr>
            )}
            {variant.variantRegistrationInfo && (
              <tr>
                <td className="trip-variant-label">Termin zapisów</td>
                <td className="registration-with-dot">
                  <span className={`regstatus-dot regstatus-${variant.variantRegistrationInfo.status}`}></span>
                  {formatDateTime(variant.variantRegistrationInfo.registrationStart)} –{" "}
                  {formatDateTime(variant.variantRegistrationInfo.registrationEnd)}
                </td>
              </tr>
            )}

             <tr>
          <td className="trip-variant-label">Termin wariantu</td>
          <td>
            {formatDateTime(variant.startDate)} –{" "}
            {formatDateTime(variant.endDate)}
          </td>
        </tr>
          <tr>
            <td className="trip-variant-label">Cena wariantu</td>
            <td>{variant.pricePerPerson ?? 0} zł</td>
          </tr>
          <tr>
            <td className="trip-variant-label">Procent przedpłaty</td>
            <td>{variant.prepaymentPercentage ? `${variant.prepaymentPercentage}%` : "-"}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <VariantRegistrations
  registrations={tripData.registrations}
  variantGuid={variant.guid}
   activeSectionRef={activeSectionRef}
/>
  </div>
  {showMailPopup && (
        <BulkMailPopup
          onClose={() => setShowMailPopup(false)}
          registrations={registrationsForList}
          variantGuid={variant.guid}
        />
      )}

  {showCorrectionPopup && (
  <BulkCorrectionPopup
    onClose={() => setShowCorrectionPopup(false)}
    participants={tripData.registrations
      .filter(r => r.variantGuid === variant.guid)
      .filter(r => r.status === 3 || r.status === 4 || r.status === 5)
      .flatMap(r => r.participants || [])
      .filter(p => p.status !== 5)
      .sort((a, b) => a.preferredName.localeCompare(b.preferredName))}
      
    variantGuid={variant.guid}
  />
)}
  </>
  
  );
};

export default VariantDetails;
